"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _Tab = _interopRequireDefault(require("../common/Tab/Tab"));
var _MarginBalances = require("../MarginBalances");
require("./InstrumentPositionsTabsComponent.css");
var _InstrumentPositionsContainer = _interopRequireDefault(require("../InstrumentPositions/InstrumentPositionsContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('instrument-positions-tabs');
var InstrumentPositionsTabsComponent = function InstrumentPositionsTabsComponent() {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var _getPanes = function _getPanes() {
    return [{
      menuItem: t('Margin Overview'),
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement(_MarginBalances.MarginOverviewContainer, {
          showTitle: false
        });
      }
    }, {
      menuItem: t('Balances'),
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement(_InstrumentPositionsContainer["default"], {
          showTitle: false
        });
      }
    }];
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
    panes: _getPanes(),
    customClass: baseClasses()
  }));
};
var _default = exports["default"] = InstrumentPositionsTabsComponent;